import type { SegmentTrackProductSharedEvent } from "@beautypie/segment/Track/ProductShared";
import { track } from "tracking";

export const trackSegmentProductShared = ({
  sku,
  name,
  brand,
  variant,
  price,
  membersPrice,
  typicalPrice,
  currency,
  url
}: {
  sku: string;
  name: string;
  brand: string;
  variant: string;
  price: number;
  membersPrice: number;
  typicalPrice: number;
  currency: string;
  url: string;
}): void => {
  const data: SegmentTrackProductSharedEvent = {
    event: "Product Shared",
    properties: {
      sku,
      name,
      brand,
      variant,
      price,
      members_price: membersPrice,
      typical_price: typicalPrice,
      currency,
      url
    }
  };

  track(data);
};
